import { createApp } from 'vue'

import { installPlugins } from '@/plugins'

import MaApp from '@/pages/main/MaApp.vue'

const app = createApp(MaApp)

installPlugins(app)

app.mount('#ma-app')

const { globalProperties } = app.config

export { globalProperties }
